module.exports = __webpack_public_path__ + "img/v2.9a60ac84.jpg";